import { render } from "./Congratulation.vue?vue&type=template&id=7face1b9&scoped=true"
import script from "./Congratulation.vue?vue&type=script&lang=js"
export * from "./Congratulation.vue?vue&type=script&lang=js"

import "./Congratulation.vue?vue&type=style&index=0&id=7face1b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7face1b9"]])

export default __exports__